import { useQuery } from '@tanstack/react-query';
import type { DiscordTokenStatus } from '@/Config/api/queryClient';
import { QueryKey } from '@/Config/api/queryKey';

/**
 * Whether the scenario has a Discord bot token set. Used to gate the {{discord_bot_token}}
 * System Token in the AI Action variable picker.
 *
 * Backed by the boolean-only `/integration/discord/token-status` endpoint (mirrors the HubSpot
 * and Google Sheets status hooks) so the raw bot token is never shipped just to gate a dropdown.
 * The queryFn and staleTime live on the queryClient default registered for
 * `[QueryKey.integration.discordTokenStatus]` in `Config/api/queryClient.ts`.
 */
export const useDiscordTokenStatus = (): { hasToken: boolean; isFetching: boolean } => {
  const { data, isFetching } = useQuery<DiscordTokenStatus>({
    queryKey: [QueryKey.integration.discordTokenStatus],
  });
  return { hasToken: Boolean(data?.has_token), isFetching };
};
